var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#325a7c}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    transform: "translate(-1647 -335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_200",
    fill: "none",
    d: "M0 0H24V24H0z",
    transform: "translate(1647 335)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    transform: "translate(1653.132 340.128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    d: "M13.566 1.371a1.682 1.682 0 0 0-2.377 0L10 2.56l2.377 2.377 1.189-1.189a1.682 1.682 0 0 0 0-2.377z",
    className: "cls-2",
    transform: "translate(-2.076)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    d: "M2.377 13.509H0v-2.377L7.132 4l2.377 2.377z",
    className: "cls-2",
    transform: "translate(0 -.648)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon_edit.47a396b8380ee55d474d474dda130a89.svg";
export { ForwardRef as ReactComponent };